import React from 'react';
import { Github, Linkedin, Mail, ExternalLink } from 'lucide-react';
import { profile } from '../data/profile';
import XIcon from './XIcon';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img className="footer__img" src={`${process.env.PUBLIC_URL}${profile.avatar}`} alt={profile.name} />
          <div>
            <div className="footer__name">{profile.name}</div>
            <div className="footer__role">{profile.role}</div>
          </div>
        </div>

        <div className="footer__socials">
          <a href={profile.socials.github} target="_blank" rel="noreferrer" aria-label="GitHub"><Github size={19} /></a>
          <a href={profile.socials.x} target="_blank" rel="noreferrer" aria-label="X (Twitter)"><XIcon size={17} /></a>
          <a href={profile.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={19} /></a>
          <a href={profile.socials.devpost} target="_blank" rel="noreferrer" aria-label="Devpost"><ExternalLink size={19} /></a>
          <a href={profile.socials.email} aria-label="Email"><Mail size={19} /></a>
        </div>
      </div>

      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} {profile.name}</span>
        <span className="footer__loc">{profile.location}</span>
      </div>
    </footer>
  );
};

export default Footer;
